import { useEffect, useState } from "react";
import classes from "./find-account.module.css";
import { AccountDto } from "../../../services/accountService";
import {
  AccountListingPage,
  useAccounts,
} from "../../../pages/AccountListing/AccountListing";
import { MdFilterAlt, MdFilterList, MdSearch } from "react-icons/md";
import FormModal from "../FormModal";
import SearchBar from "../SearchBar/SearchBar";
import { Column, Row } from "../Layout/Layout";

export interface FindAccountProps {
  id: string;
  dataType?: dataType;
  text: string;
  onAccountSelected?: (account: AccountDto) => void;
  account?: AccountDto;
  onClearSelectedAccount?: () => void;
}

export type dataType = "text" | "number" | "date";

function FindAccount(props: FindAccountProps) {
  const { accounts } = useAccounts({ pageIndex: 1, pageSize: 10 });
  const [showAccountListing, setShowAccountListing] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState<
    AccountDto | undefined
  >(props.account);

  const closeFindAccount = () => {
    setShowAccountListing(false);
  };

  const listItems = accounts.map((d) => {
    return (
      <li className="list-group-item">
        <Row>
          <Column>
            <p>{d.name}</p>
            <small>{d.accountNo}</small>
          </Column>
          <Column>{d.customerName}</Column>
          <Column>{d.accountTypeName}</Column>
          <Column>{d.accountGroupName}</Column>
        </Row>
      </li>
    );
  });

  return (
    <div>
      <div className="form-group">
        <label htmlFor={props.id} className="control-label">
          {props.text}
        </label>
        <div>
          <div className="input-group">
            <input
              readOnly
              type="text"
              name={props.id}
              id={props.id}
              className="form-control form-control-sm"
              value={
                selectedAccount === undefined
                  ? ""
                  : selectedAccount?.accountNo +
                    " - " +
                    selectedAccount?.name?.trim()
              }
            />

            {selectedAccount !== undefined && (
              <button
                type="button"
                title="Clear Selected Account"
                className={
                  "btn btn-outline-secondary input-group-btn " +
                  classes.clearButton
                }
                onClick={(e) => {
                  setSelectedAccount(undefined);
                  props.onClearSelectedAccount?.();
                }}
              >
                <span className={"btn-close " + classes.clearButton}></span>
              </button>
            )}

            <button
              title="click to search"
              className="btn btn-sm btn-outline-secondary input-group-btn"
              onClick={() => {
                setShowAccountListing(true);
              }}
            >
              <MdFilterList size={20} />
            </button>
          </div>

          {showAccountListing && (
            <div className="dropdown show">
              <ul className="list-group">{listItems}</ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default FindAccount;
